import "./App.css";
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddPhoto from "./components/addphoto";
import Catalog from "./components/catalog";
import Wedding from "./components/wedding"
import Graduation from "./components/graduation";
import Family from "./components/family";
import Login from "./components/login";
import Availability from "./components/availability";
import Calendar from "./components/calander";
import Register from "./components/register";




function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/Addphoto" element={<AddPhoto />} />
          <Route path="/" element={<Catalog />} />
          <Route path="/wedding" element={<Wedding />} />
          <Route path="/graduation" element={<Graduation />} />\
          <Route path="/family" element={<Family />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/calendar" element={<Calendar />}/>
          <Route path="/availability" element={<Availability />}/>
          <Route path="/register" element={<Register />}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
